import { MAX_WALLET_EVENTS_REQUESTS_SIZE } from 'meta/pages/v4/wallet'

export const wallet = {
  pastEvents: (page: number) => `wallet/past/events?page=${page}&size=${MAX_WALLET_EVENTS_REQUESTS_SIZE}`,
  pastGoodsServices: (page: number) =>
    `wallet/past/goods-services?page=${page}&size=${MAX_WALLET_EVENTS_REQUESTS_SIZE}`,
  upcomingEvents: (page: number) => `wallet/events?page=${page}&size=${MAX_WALLET_EVENTS_REQUESTS_SIZE}`,
  upcomingGoodsServices: (page: number) => `wallet/goods-services?page=${page}&size=${MAX_WALLET_EVENTS_REQUESTS_SIZE}`,
  eventTicketCodes: (eventIdOrCodeUrl: string, page: number) =>
    `wallet/events/${eventIdOrCodeUrl}/tickets?page=${page}&size=${MAX_WALLET_EVENTS_REQUESTS_SIZE}`,
}
